import { render } from "./NewsLetters.vue?vue&type=template&id=fd555bd2&scoped=true"
import script from "./NewsLetters.vue?vue&type=script&lang=js"
export * from "./NewsLetters.vue?vue&type=script&lang=js"

import "./NewsLetters.vue?vue&type=style&index=0&id=fd555bd2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd555bd2"]])

export default __exports__